import { useEffect, useState } from "react";

import { useAuth } from "../actions/mutation/login";
// import { useMemo } from "react";
// import { Logout } from "./auth";
// import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { userRoleAtom } from "../../components/admin/setup/atom/Atom";
import {
  allClinicsAtom,
  allPharmacyAtom,
  clinicAtom,
  doctorListAtom,
  doctorSettingAtom,
  permissionAtom,
  pharmacyAtom,
  selectedDoctorAtom,
} from "./constant-atom";
import { useItemsFilter, useItemsFilterNew } from "../actions/app/items";
import { ApiEndPoint } from "./api-types";
import {
  consultationJSONAtom,
  prescriptionSetupAtom,
  setInitialConsultationOrdering,
  tagTypesAtom,
} from "../../new_consultation/constants/_constant";
import { capitalizeFirstWord } from "../utils/utils";
import { useCreateItem } from "../actions/mutation/items";
import { toast } from "react-toastify";
// import { getImageURLwithouttoken } from "../utils/image";

export const PERMISSONS = {
  Administrator: {},
  Doctor: {
    appointment: {
      walkin_appointment: true,
      online_consultation: false,
    },
  },
  Patient: {},
  Receptionist: {},
};

// {
//   name:"doctor",
//   "permission_set":{
//   "appointment":{
//   "walkin_appointment":true,
//   "online_consultation:"false",
//   },
//   "consultation":false
//   "all_patient":{
//   "search":"false}
//   }

export const usePermissions = () => {
  const { data, isLoading, isSuccess } = useAuth(
    localStorage.getItem("access_token") != null ? true : false
  );
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    setPermissions({
      name: data?.data?.role?.name,
      permissions: PERMISSONS[data?.data?.role.name],
    });
  }, [isSuccess, data]);

  return {
    permissions: permissions || {},
    isLoading,
    isSuccess,
  };
};

export const useCurrentRole = () => {
  const { data, isLoading, isSuccess, refetch } = useAuth();
  const [, setClinicData] = useAtom(userRoleAtom);
  const [clinic, setClinic] = useAtom(clinicAtom);
  const [pharmacy, setPharmacy] = useAtom(pharmacyAtom);
  const [, setAllClinic] = useAtom(allClinicsAtom);
  const [, setAllPharmacy] = useAtom(allPharmacyAtom);
  const [, setDoctoList] = useAtom(doctorListAtom);
  const [selectedDoctor, setSelectedDoctor] = useAtom(selectedDoctorAtom);
  const [, setPermission] = useAtom(permissionAtom);
  const [, setDoectorSetting] = useAtom(doctorSettingAtom);
  const [consultationJSON, setConsultationJSON] = useAtom(consultationJSONAtom);
  const [, setTagType] = useAtom(tagTypesAtom);
  // const [prescriptionSetup, setPrescriptionSetup] = useAtom(
  //   prescriptionSetupAtom
  // );

  // console.log("Pharmacy", pharmacy);
  const [role, setRole] = useState({
    id: null,
    name: "",
    linked_clinics: "",
    linked_pharmacy: [],
  });

  const postSettigs = useCreateItem(ApiEndPoint?.CLINIC);

  const postDoctorSettings = (payload) => {
    postSettigs.mutate(payload, {
      onSuccess: (data) => {
        setConsultationJSON(data?.data?.consultation_setup);
        setDoectorSetting({
          id: data?.data?.id,
          consultation_setup: data?.data?.consultation_setup,
          edit_invoice_permissions: data?.data?.edit_invoice_permissions,
          invoice_on_end_consultation: data?.data?.invoice_on_end_consultation,
          is_online_appointment: data?.data?.is_online_appointment,
          prescription_setup: data?.data?.prescription_setup,
          header_footer_setup: data?.data?.header_footer_setup,
        });
        // setPrescriptionSetup({
        //   ...data?.data?.prescription_setup,
        //   id: data?.data?.id,
        // });
      },
      onError: (err) => toast.error(err.response.data.message),
    });
  };

  const setInitialConsultationJSON = (response) => {
    setTagType(response);
    const customfields =
      response.data?.map((tag, i) => {
        return {
          id: consultationJSON?.length + (i + 1),
          label: capitalizeFirstWord(tag?.name),
          offset: "TAGS",
          key: "customField",
          tagId: tag?.id,
        };
      }) || [];
    const orderedJSON = setInitialConsultationOrdering([
      ...customfields,
      ...consultationJSON,
    ]);

    if (doctorSettingData?.length > 0) {
      setConsultationJSON(doctorSettingData[0]?.consultation_setup);
      setDoectorSetting({
        id: doctorSettingData[0]?.id,
        consultation_setup: doctorSettingData[0]?.consultation_setup,
        edit_invoice_permissions:
          doctorSettingData[0]?.edit_invoice_permissions,
        invoice_on_end_consultation:
          doctorSettingData[0]?.invoice_on_end_consultation,
        is_online_appointment: doctorSettingData[0]?.is_online_appointment,
        prescription_setup: doctorSettingData[0]?.prescription_setup,
        header_footer_setup: doctorSettingData[0]?.header_footer_setup,
      });
      // setPrescriptionSetup({
      //   ...doctorSettingData[0]?.prescription_setup,
      //   id: doctorSettingData[0]?.id,
      // });
    } else {
      const payload = {
        action: "postDoctorSetting",
        clinic_id: clinic?.id,
        backend: "True",
        prescription_setup: {
          marginLeft: "0",
          marginRight: "0",
          marginTop: "0",
          marginBottom: "0",
          pageSize: "A4",
          signatureImg: "",
          signatureText: "",
          signatureHeight: "1",
          signatureWidth: "1",
          pageOrdering: orderedJSON,
          printSignature: false,
        },
        consultation_setup: orderedJSON,
        header_footer_setup: {
          A3: {
            headerHeight: "3",
            footerHeight: "3",
            pageSize: "A3",
            headerUrl: "",
            footerUrl: "",
          },
          A4: {
            headerHeight: "3",
            footerHeight: "3",
            pageSize: "A4",
            headerUrl: "",
            footerUrl: "",
          },
          A5: {
            headerHeight: "3",
            footerHeight: "3",
            pageSize: "A5",
            headerUrl: "",
            footerUrl: "",
          },
        },
        doctor_user: selectedDoctor || role?.id,
      };
      postDoctorSettings(payload);
    }
  };

  const { user } = data?.data || { user: "" };
  const { linked_pharmacy } = data?.data || { linked_pharmacy: [] };

  const { data: linkedDoctors } = useItemsFilter(
    ApiEndPoint.USERS,
    `?action=getClinicDoctors&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id && isSuccess ? true : false
  );

  const { data: userRoles } = useItemsFilter(
    ApiEndPoint.USERS,
    `?action=getRoles&frontend=True&clinic_id=${clinic?.id}`,
    clinic?.id && isSuccess ? true : false
  );

  const { data: pharmacyUserRoles } = useItemsFilter(
    ApiEndPoint.USERS,
    `?action=getRoles&frontend=True&pharmacy_id=${pharmacy?.id}`,
    pharmacy?.id && isSuccess ? true : false
  );

  const query = `?action=getDoctorSetting&frontend=True&clinic_id=${clinic?.id}`;
  const { data: doctorSettingData, isSuccess: isDrSettingSuccess } =
    useItemsFilter(
      ApiEndPoint?.CLINIC,
      query,
      clinic?.id && isSuccess ? true : false
    );

  const { data: tagTypes } = useItemsFilterNew(
    ApiEndPoint.QP_CM_TAG_TYPES,
    `?action=getTagTypes&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id && isSuccess && isDrSettingSuccess ? true : false,
    setInitialConsultationJSON
  );

  useEffect(() => {
    if (doctorSettingData) {
      setDoectorSetting({
        id: doctorSettingData[0]?.id,
        consultation_setup: doctorSettingData[0]?.consultation_setup,
        // doctor_user: doctorSettingData[0]?.doctor_user,
        edit_invoice_permissions:
          doctorSettingData[0]?.edit_invoice_permissions,
        invoice_on_end_consultation:
          doctorSettingData[0]?.invoice_on_end_consultation,
        is_online_appointment: doctorSettingData[0]?.is_online_appointment,
        prescription_setup: doctorSettingData[0]?.prescription_setup,
        header_footer_setup: doctorSettingData[0]?.header_footer_setup,
        // user_created: doctorSettingData[0]?.user_created,
      });
    }
  }, [doctorSettingData]);

  useEffect(() => {
    if (linkedDoctors) {
      setDoctoList(linkedDoctors);
      if (linkedDoctors?.length > 0) {
        setSelectedDoctor(linkedDoctors[0]?.id);
      }
    }
  }, [linkedDoctors]);

  useEffect(() => {
    if (userRoles?.length > 0) {
      setPermission({
        id: userRoles[0]?.id,
        role: userRoles[0]?.name,
        allowed_features: userRoles[0]?.frontend_permissions,
      });
    }
  }, [userRoles]);

  useEffect(() => {
    if (pharmacyUserRoles?.length > 0) {
      setPermission({
        id: pharmacyUserRoles[0]?.id,
        role: pharmacyUserRoles[0]?.name,
        allowed_features: pharmacyUserRoles[0]?.frontend_permissions,
      });
    }
  }, [pharmacyUserRoles]);

  // console.log("Pharmacy User Roles", );

  useEffect(() => {
    if (data) {
      setClinicData({
        id: user?.id,
        first_name: user?.first_name,
        last_name: user?.last_name,
      });
      // console.log("data..", user);

      if (!user) {
        // console.log("data", data);
        setClinicData({
          id: data?.data?.id,
          first_name: data?.data?.first_name,
          last_name: data?.data?.last_name,
        });
      }

      const linked_clinics = user?.linked_clinics || [];

      // console.log("user", user);

      const selectedClinicId = localStorage.getItem("clinic");
      const selectedPharmacyID = localStorage.getItem("pharmacy");
      setAllClinic(linked_clinics);
      setAllPharmacy(linked_pharmacy);

      if (selectedClinicId) {
        const selectedClinic = linked_clinics?.find(
          (clinic) => clinic?.id === Number(selectedClinicId)
        );
        setClinic(selectedClinic);
      } else {
        if (linked_clinics?.length > 0) {
          localStorage.setItem("clinic", linked_clinics[0]?.id);
          setClinic(linked_clinics[0]);
        }
      }

      if (selectedPharmacyID) {
        const selectedPharmacy = linked_pharmacy?.find(
          (pharmacy) => pharmacy?.id === Number(selectedPharmacyID)
        );
        setPharmacy(selectedPharmacy);
      } else {
        if (linked_pharmacy?.length > 0) {
          localStorage.setItem("pharmacy", linked_pharmacy[0]?.id);
          setPharmacy(linked_pharmacy[0]);
        }
      }

      setRole({
        id: user?.id,
        name: "doctor",
      });
    } else {
      setRole({
        id: null,
        name: "",
      });
    }
  }, [data]);

  // console.log("bp", user);

  return {
    role_id: selectedDoctor || role.id,
    role_name: role.name,
    linked_clinics: role.linked_clinics,
    linked_pharmacy: linked_pharmacy,
    family_id: role.family_id,
    linked_doctors: role.linked_doctors,
    doctor_setting_id: role.doctor_setting_id,
    user_personal_details_id: role.user_personal_details_id,
    bhp_registered_clinic: user?.linked_clinics,
    isLoading,
    isSuccess,
    setRole,
    refetch,
    doctor_personal_details: data?.data?.user?.doctor_personal_details,
  };
};
